import moment from 'moment'
import { SkudGuestEndpoint } from '@/views/skud/shared/endpoint_services/skud-guest-endpoint-service'
import { GuestPassState, enumText, guestStateColor } from '@/views/skud/shared/models/enums'

// Тонкий сервис гостевых пропусков: декод state в state_text/state_color, даты в 'DD.MM.YYYY HH:mm'.
export class SkudGuestService {
  constructor () {
    this.endpoint = new SkudGuestEndpoint()
  }

  decorate (g) {
    if (!g) return g
    g.state_text = enumText(GuestPassState, g.state)
    g.state_color = guestStateColor(g.state)
    for (const f of ['valid_from', 'valid_to', 'revoked_at', 'created_at', 'name_erased_at']) {
      g[f] = g[f] ? moment(g[f]).format('DD.MM.YYYY HH:mm') : null
    }
    // QR отдаётся Charon только для активного пропуска; в остальных состояниях URL будет 404.
    if (Number(g.state) === 0) {
      const base = process.env.VUE_APP_CHARON_URL.replace(/\/$/, '')
      // QR не пришёл — вычисляем по public_id.
      if (!g.qr_png_url) g.qr_png_url = `${base}/acs/guest/${g.public_id}.png`
      // Относительную QR-ссылку префиксуем базовым URL Charon, абсолютную не трогаем.
      if (g.qr_png_url.startsWith('/')) g.qr_png_url = base + g.qr_png_url
    } else {
      g.qr_png_url = null
    }
    return g
  }

  // -> {ok: true, data} | {ok: false, error}
  async createGuest (placeId, body) {
    const r = await this.endpoint.createGuest(placeId, body)
    if (r.ok) r.data = this.decorate(r.data)
    return r
  }

  // -> {ok: true, data} | {ok: false, error}
  async revokeGuest (placeId, body) {
    return this.endpoint.revokeGuest(placeId, body)
  }

  // -> массив пропусков ([] при ошибке).
  async getGuests (placeId, params) {
    params = Object.assign({}, params)
    // Дата «по» из фильтра — без времени, включаем весь день.
    if (params.to && params.to.length === 10) params.to += 'T23:59:59'
    const data = await this.endpoint.getGuests(placeId, params)
    if (!data || !data.items) return []
    return data.items.map(g => this.decorate(g))
  }

  // -> объект пропуска или null.
  async getGuest (placeId, publicId) {
    const g = await this.endpoint.getGuest(placeId, publicId)
    return g ? this.decorate(g) : null
  }
}
